export default __webpack_public_path__ + "static/media/night_half_moon_rain_thunder.aedccc1f.svg";